<div [formGroup]="form">
    <app-edit-person-form formGroupName="person"></app-edit-person-form>
</div>
